/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-refresh/only-export-components */
/* eslint-disable react-hooks/exhaustive-deps */

import {
  Box,
  Button,
  Center,
  Divider,
  Flex,
  Icon,
  IconButton,
  Menu,
  MenuButton,
  MenuDivider,
  MenuItem,
  MenuList,
  Spacer,
  Text,
  Tooltip,
  useDisclosure,
  useToast,
} from '@chakra-ui/react'
import { ReactElement, ReactNode, createContext, useContext, useEffect, useState } from 'react'
import { GoQuestion } from 'react-icons/go'
import { PiRadio } from 'react-icons/pi'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'
import useMobile from '../../hooks/useMobile'
import { HiOutlineCurrencyDollar } from 'react-icons/hi2'

import { scrollbarStyle } from '../../theme/scrollbarStyles'
import {
  Community,
  CommunityFilled,
  ErrorPrompt,
  Events,
  EventsFilled,
  Home,
  HomeFilled,
  ListHamburger,
  Messages,
  MessagesActive,
  MessagesActiveFilled,
  MessagesFilled,
  NotificationFilled,
  Notifications,
  NotificationsActive,
  NotificationsActiveFilled,
  PlusSlim,
  Settings,
  Shop,
  ShopFilled,
  Tennis,
  TennisFilled,
} from '../icons/icons'

import PlaySearchFilter from '../input/PlaySearchFilter'

import { Haptics, ImpactStyle } from '@capacitor/haptics'
import { Keyboard } from '@capacitor/keyboard'

import { useMutation, useQueryClient } from 'react-query'
import { useHealthKitSync } from '../../hooks/useHealthKitSync'

import { SafeArea } from 'capacitor-plugin-safe-area'

import { App } from '@capacitor/app'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import { Geolocation } from '@capacitor/geolocation'

import { AppTrackingTransparency } from 'capacitor-plugin-app-tracking-transparency'

import { Capacitor } from '@capacitor/core'
import { TbPlus } from 'react-icons/tb'
import { AuthContext } from '../../App'
import { patchRegistration, putLocation } from '../../api/user/home/home'
import { getChats } from '../../api/user/messages/Messages'
import { getNotifications } from '../../api/user/notifications/Notifications'
import { postReport } from '../../api/user/settings/Settings'
import UserCommunitySearchHeader from '../headers/UserCommunityHeader'
import UserDefaultHeader from '../headers/UserDefaultHeader'
import UserMessagesSearchHeader from '../headers/UserMessagesSearchHeader'
import UserNotificationHeader from '../headers/UserNotificationHeader'
import UserProfileHeader from '../headers/UserProfileHeader'
import UserSettingsHeader from '../headers/UserSettingsHeader'
import UserTitleBackHeader from '../headers/UserTitleBackHeader'
import LazyAvatar from '../lazy/LazyAvatar'
import HealthKitPromptModal from '../modals/HealthKitPromptModal'
import ProfilePhotoPromptModal from '../modals/ProfilePhotoPromptModal'
import ReportErrorModal from '../modals/ReportErrorModal'
import UserOnboardingModal from '../modals/UserOnboardingModal'
import handleToast from '../toast/handleToast'

const NavButton = (props: { label: string; path: string; icon: ReactElement; filledIcon: ReactElement; disabled?: boolean }) => {
  const location = useLocation()
  const isActive =
    !props.disabled && (location.pathname === props.path ||
    location.pathname === `${props.path}/` ||
    (location.pathname.includes(props.path) && props.path !== '/user'))

  const content = (
    <Flex alignItems="center" gap="10px" mb="30px" opacity={props.disabled ? 0.4 : 1} cursor={props.disabled ? 'default' : 'pointer'}>
      <Icon w="24px" h="24px">
        {isActive ? props.filledIcon : props.icon}
      </Icon>
      <Text color="#171C22" fontSize={isActive ? 'lg' : 'md'} lineHeight="20px" fontWeight={isActive ? '600' : '500'}>
        {props.label}
      </Text>
    </Flex>
  )

  if (props.disabled) {
    return (
      <Tooltip hasArrow bg="black" p="8px" borderRadius="12px" label="Log in to access this page" placement="right">
        {content}
      </Tooltip>
    )
  }

  return <Link to={props.path}>{content}</Link>
}
const MobileNavButton = (props: { path: string; icon: ReactElement; filledIcon: ReactElement; disabled?: boolean; tooltipOpen?: boolean; onTooltipToggle?: () => void }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const isActive =
    !props.disabled && (location.pathname === props.path ||
    location.pathname === `${props.path}/` ||
    (location.pathname.includes(props.path) && props.path !== '/user'))

  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  }

  return (
    <Tooltip
      hasArrow
      bg="black"
      p="8px"
      borderRadius="12px"
      label="Log in to access this page"
      placement="top"
      isDisabled={true}
      isOpen={false}
    >
      <Button
        onClick={() => {
          if (props.disabled) {
            navigate(props.path)
            return
          }
          navigate(props.path)
          triggerHapticFeedback(ImpactStyle.Medium)
        }}
        bg="transparent"
        opacity={props.disabled ? 0.4 : 1}
        _active={{
          bg: 'transparent',
          boxShadow: 'none',
          border: 'none',
        }}
        _hover={{
          bg: 'transparent',
          boxShadow: 'none',
          border: 'none',
        }}
        _focus={{
          bg: 'transparent',
          boxShadow: 'none',
          border: 'none',
          outline: 'none',
        }}
        css={{
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        }}
      >
        <Box w="28px">
          <Icon
            userSelect={'none'}
            w="28px"
            h="28px"
            _active={{
              bg: 'transparent',
              boxShadow: 'none',
              border: 'none',
            }}
            _hover={{
              bg: 'transparent',
              boxShadow: 'none',
              border: 'none',
            }}
            _focus={{
              bg: 'transparent',
              boxShadow: 'none',
              border: 'none',
              outline: 'none',
            }}
          >
            {isActive ? props.filledIcon : props.icon}
          </Icon>
          <Box w="4px" h="4px" borderRadius="2px" bg={isActive ? '#171C22' : 'white'} m="8px auto" transition="0.2s" />
        </Box>
      </Button>
    </Tooltip>
  )
}
const ProfileButton = (props: { label: string; path: string; avatar: string; disabled?: boolean }) => {
  const location = useLocation()

  const isActive =
    !props.disabled && (location.pathname === props.path ||
      location.pathname === `${props.path}/` ||
      (location.pathname.includes(props.path) && props.path !== '/user')) &&
    location.search === ''

  const content = (
    <Flex alignItems="center" gap="10px" mb="30px" position="absolute" left="21px" opacity={props.disabled ? 0.4 : 1} cursor={props.disabled ? 'default' : 'pointer'}>
      <LazyAvatar width={24} height={24} src={props.avatar} />
      <Text fontSize={isActive ? 'lg' : 'md'} lineHeight="20px" color="#171C22" fontWeight={isActive ? '600' : '500'}>
        {props.label}
      </Text>
    </Flex>
  )

  if (props.disabled) {
    return (
      <Tooltip hasArrow bg="black" p="8px" borderRadius="12px" label="Log in to access this page" placement="right">
        {content}
      </Tooltip>
    )
  }

  return <Link to={props.path}>{content}</Link>
}
const MobileProfileButton = (props: { path: string; avatar: string; disabled?: boolean; tooltipOpen?: boolean; onTooltipToggle?: () => void }) => {
  const location = useLocation()
  const navigate = useNavigate()
  const isActive =
    !props.disabled && (location.pathname === props.path ||
    location.pathname === `${props.path}/` ||
    (location.pathname.includes(props.path) && props.path !== '/user'))

  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  }
  return (
    <Tooltip
      hasArrow
      bg="black"
      p="8px"
      borderRadius="12px"
      label="Log in to access this page"
      placement="top"
      isDisabled={true}
      isOpen={false}
    >
      <Button
        bg="transparent"
        opacity={props.disabled ? 0.4 : 1}
        _hover={{}}
        _active={{}}
        onClick={() => {
          if (props.disabled) {
            navigate(props.path)
            return
          }
          triggerHapticFeedback(ImpactStyle.Medium)
          navigate(props.path)
        }}
        css={{
          '&:focus': {
            outline: 'none',
            boxShadow: 'none',
          },
          '-webkit-tap-highlight-color': 'rgba(0,0,0,0)',
        }}
      >
        <Box w="28px">
          <LazyAvatar width={28} height={28} src={props.avatar} />
          <Box w="4px" h="4px" borderRadius="2px" bg={isActive ? '#171C22' : 'white'} m="8px auto" transition="0.2s" />
        </Box>
      </Button>
    </Tooltip>
  )
}

type UserWrapperContextType = {
  notificationScreen: 'notifications' | 'events' | 'calendar'
  setNotificationScreen: React.Dispatch<React.SetStateAction<'notifications' | 'events' | 'calendar'>>

  newMessage: string
  setNewMessage: React.Dispatch<React.SetStateAction<string>>

  filterActive: boolean
  setFilterActive: React.Dispatch<React.SetStateAction<boolean>>

  currentChat: any
  setCurrentChat: React.Dispatch<React.SetStateAction<any>>

  topCollapsed: boolean
  setTopCollapsed: React.Dispatch<React.SetStateAction<boolean>>

  timeframeDate: Date | null
  setTimeframeDate: React.Dispatch<React.SetStateAction<Date | null>>

  timeframeStartHour: number
  setTimeframeStartHour: React.Dispatch<React.SetStateAction<number>>

  timeframeStopHour: number
  setTimeframeStopHour: React.Dispatch<React.SetStateAction<number>>

  mapToggled: boolean
  setMapToggled: React.Dispatch<React.SetStateAction<boolean>>

  timeframeToggled: boolean
  setTimeframeToggled: React.Dispatch<React.SetStateAction<boolean>>

  mobileTimeParams: any
  setMobileTimeParams: React.Dispatch<React.SetStateAction<any>>

  filterToggled: boolean
  setFilterToggled: React.Dispatch<React.SetStateAction<boolean>>

  search: string
  setSearch: React.Dispatch<React.SetStateAction<string>>

  searchCommunity: string
  setSearchCommunity: React.Dispatch<React.SetStateAction<string>>

  searchPlay: string
  setSearchPlay: React.Dispatch<React.SetStateAction<string>>

  searchActive: boolean
  setSearchActive: React.Dispatch<React.SetStateAction<boolean>>

  location: string
  setLocation: React.Dispatch<React.SetStateAction<string>>

  imageSelect: boolean
  setImageSelect: (v: boolean) => void

  galleryIndex: number
  setGalleryIndex: (v: number) => void

  communityFilters: {
    gender: string
    age_range: string
    skill_level: string
    offers_private_lessons: boolean | null
    range: number | null
  }
  setCommunityFilters: React.Dispatch<
    React.SetStateAction<{
      gender: string
      age_range: string
      skill_level: string
      offers_private_lessons: boolean | null
      range: number | null
    }>
  >
}

const transition = '0.2s ease-out'

const UserWrapperContext = createContext<UserWrapperContextType>({
  notificationScreen: 'notifications',
  setNotificationScreen: (_: any) => {},
  newMessage: '',
  setNewMessage: (_: any) => {},
  currentChat: [],
  setCurrentChat: (_: any) => {},
  searchActive: false,
  setSearchActive: (_: any) => {},

  topCollapsed: false,
  setTopCollapsed: (_: any) => {},

  timeframeDate: null,
  setTimeframeDate: (_: any) => {},
  timeframeStartHour: -1,
  setTimeframeStartHour: (_: any) => {},
  timeframeStopHour: -1,
  setTimeframeStopHour: (_: any) => {},

  filterActive: false,
  setFilterActive: (_: any) => {},

  mobileTimeParams: null,
  setMobileTimeParams: (_: any) => {},

  timeframeToggled: false,
  setTimeframeToggled: (_: any) => {},
  filterToggled: false,
  setFilterToggled: (_: any) => {},
  mapToggled: false,
  setMapToggled: (_: any) => {},
  location: '',
  setLocation: (_: any) => {},
  search: '',
  setSearch: (_: any) => {},

  searchCommunity: '',
  setSearchCommunity: (_: any) => {},

  searchPlay: '',
  setSearchPlay: (_: any) => {},

  imageSelect: false,
  setImageSelect: (_: boolean) => {},
  galleryIndex: 0,
  setGalleryIndex: (_: number) => {},

  communityFilters: {
    gender: '',
    age_range: '',
    skill_level: '',
    offers_private_lessons: null,
    range: null,
  },
  setCommunityFilters: (_: any) => {},
})

const UserWrapperContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentChat, setCurrentChat] = useState<any[]>([])
  const [newMessage, setNewMessage] = useState<string>('')

  const [topCollapsed, setTopCollapsed] = useState<boolean>(false)

  const [timeframeDate, setTimeframeDate] = useState<Date | null>(null)
  const [timeframeStartHour, setTimeframeStartHour] = useState(-1)
  const [timeframeStopHour, setTimeframeStopHour] = useState(-1)

  const [filterToggled, setFilterToggled] = useState(false)
  const [mapToggled, setMapToggled] = useState(false)
  const [timeframeToggled, setTimeframeToggled] = useState(false)
  const [search, setSearch] = useState('')
  const [searchActive, setSearchActive] = useState(false)
  const [searchCommunity, setSearchCommunity] = useState('')
  const [searchPlay, setSearchPlay] = useState('')

  const [filterActive, setFilterActive] = useState(false)
  const [location, setLocation] = useState('')
  const [mobileTimeParams, setMobileTimeParams] = useState<any>(null)

  const [imageSelect, setImageSelect] = useState<boolean>(false)
  const [galleryIndex, setGalleryIndex] = useState<number>(0)

  const [notificationScreen, setNotificationScreen] = useState<'notifications' | 'events' | 'calendar'>('notifications')

  const [communityFilters, setCommunityFilters] = useState<{
    gender: string
    age_range: string
    skill_level: string
    offers_private_lessons: boolean | null
    range: number | null
  }>({
    gender: '',
    age_range: '',
    skill_level: '',
    offers_private_lessons: null,
    range: null,
  })

  const contextValue: UserWrapperContextType = {
    notificationScreen,
    setNotificationScreen,

    newMessage,
    setNewMessage,
    currentChat,
    setCurrentChat,
    searchActive,
    setSearchActive,

    topCollapsed,
    setTopCollapsed,

    filterActive,
    setFilterActive,

    timeframeDate,
    setTimeframeDate,
    timeframeStartHour,
    setTimeframeStartHour,
    timeframeStopHour,
    setTimeframeStopHour,

    mobileTimeParams,
    setMobileTimeParams,

    timeframeToggled,
    setTimeframeToggled,
    filterToggled,
    setFilterToggled,
    mapToggled,
    setMapToggled,
    location,
    setLocation,
    search,
    setSearch,
    searchCommunity,
    setSearchCommunity,
    searchPlay,
    setSearchPlay,

    imageSelect,
    setImageSelect,
    galleryIndex,
    setGalleryIndex,

    communityFilters,
    setCommunityFilters,
  }

  return <UserWrapperContext.Provider value={contextValue}>{children}</UserWrapperContext.Provider>
}
export const useUserWrapperContext = () => {
  const context = useContext(UserWrapperContext)
  // if (!context) {
  //   throw new Error('useUserWrapperContext must be used within a UserWrapperContextProvider');
  // }
  return context
}

const UserWrapperContent = ({ children }: { children: ReactNode }) => {
  const location = useLocation()
  const navigate = useNavigate()

  const isMobile = useMobile(600)
  const isTablet = useMobile(850)
  const isTabletCommunity = useMobile(1160) // Match Community page breakpoint
  // On mobile (< 600px): show header search (Community page doesn't have its own)
  // On tablet (600px - 1160px): hide header search (Community page has its own)
  // On desktop (>= 1160px): show header search
  const shouldShowCommunityHeaderSearch = isMobile || !isTabletCommunity

  const isPlay = location.pathname.includes('user/play')
  const isPlayExpand = location.pathname.includes('user/play/') && location.pathname.split('/').length > 3
  const isCommunity = location.pathname.includes('user/community')
  const isMessages = location.pathname.includes('user/messages')
  const isProfile = location.pathname.includes('user/profile')

  const isNotifications = location.pathname.includes('user/notifications') || location.pathname.includes('user/events')
  const isBecomeHost = location.pathname.includes('user/become-a-host') || location.pathname.includes('user/become-a-coach')
  const isCreateEvent = location.pathname.includes('host/event/create') && !location.pathname.includes('success')
  const isEditEvent = location.pathname.includes('host/event/edit') && !location.pathname.includes('success')
  const isNewLocation = location.pathname.includes('host/location/create')
  const isEditLocation = location.pathname.includes('host/location/edit')
  const isEvents = location.pathname.includes('host/events')

  const { user, isHost, setIsHost, logout, loading: authLoading } = useContext(AuthContext)

  const toast = useToast()

  const addReport = useMutation(['reportError'], postReport, {
    onSuccess: () => {
      handleToast(toast, 'Your report has been sent successfully')
      onReportErrorModalClose()
    },
    onError: () => {
      handleToast(toast, 'An error occurred while sending the report')
    },
  })

  if (location.pathname.includes('user/play') && isHost == true) navigate('/host/events')
  if (location.pathname.includes('host/event') && isHost == false) navigate('/user/play')

  const isSettings = location.pathname.includes('user/settings')

  const {
    isOpen: isReportErrorModalOpen,
    onClose: onReportErrorModalClose,
    onOpen: onReportErrorModalOpen,
  } = useDisclosure()

  // const isHome =
  //   !isPlay &&
  //   !isCommunity &&
  //   !isMessages &&
  //   !isProfile &&
  //   !isSettings &&
  //   !isBecomeHost &&
  //   !isCreateEvent &&
  //   !isEditEvent &&
  //   !isNewLocation &&
  //   !isEditLocation &&
  //   !isEvents
  const displayDefaultHeader =
    !isMessages &&
    !isProfile &&
    !isNotifications &&
    !isSettings &&
    !isBecomeHost &&
    !isCreateEvent &&
    !isEditEvent &&
    !isNewLocation &&
    !isEditLocation
  // const noBottomPadding =
  //   isHome ||
  //   isProfile ||
  //   isSettings ||
  //   isBecomeHost ||
  //   isCreateEvent ||
  //   isEditEvent ||
  //   isEditLocation ||
  //   isNewLocation ||
  //   isPlayExpand

  const {
    // topCollapsed,
    // setTopCollapsed,
    mapToggled,
    currentChat,
    setImageSelect,
    galleryIndex,
    setGalleryIndex,
  } = useUserWrapperContext()
  // const [prevScrollY, setPrevScrollY] = useState(0)

  const onImageSelectOpen = () => setImageSelect(true)
  const user_id = user?.member_profile?.id
  const [searchParams] = useSearchParams()
  const profile_id = searchParams.get('id')

  useEffect(() => {
    setGalleryIndex(0)
  }, [profile_id])

  const isOwnProfileGallery = isProfile && galleryIndex == 0 && (user_id == profile_id || profile_id == null)

  const [newNotification, setNewNotification] = useState(0)
  const [newMessage, setNewMessage] = useState(0)
  const [mobileLoginTooltip, setMobileLoginTooltip] = useState(false)

  // Auto-dismiss mobile login tooltip after 2 seconds
  useEffect(() => {
    if (mobileLoginTooltip) {
      const timer = setTimeout(() => setMobileLoginTooltip(false), 2000)
      return () => clearTimeout(timer)
    }
  }, [mobileLoginTooltip])

  useEffect(() => {
    if (!user) return

    const POLL_INTERVAL = 30000 // 30 seconds

    const fetchChats = async () => {
      try {
        const messages = !user?.is_staff ? await getChats({ unreadsOnly: true }) : []
        const newMessage = messages?.data?.length ?? 0
        setNewMessage(newMessage)
      } catch (error) {
        console.error('Error fetching chats:', error)
      }
    }

    const fetchNotifications = async () => {
      try {
        const notifications = !user?.is_staff ? await getNotifications({ unread: true }) : []
        const newNotification = notifications?.count ?? 0
        setNewNotification(newNotification)
      } catch (error) {
        console.error('Error fetching notifications:', error)
      }
    }

    fetchChats()
    fetchNotifications()

    let chatInterval: NodeJS.Timeout = setInterval(fetchChats, POLL_INTERVAL)
    let notificationInterval: NodeJS.Timeout = setInterval(fetchNotifications, POLL_INTERVAL)

    // Pause polling when tab/app is not visible, resume when visible
    const handleVisibilityChange = () => {
      if (document.hidden) {
        clearInterval(chatInterval)
        clearInterval(notificationInterval)
      } else {
        fetchChats()
        fetchNotifications()
        chatInterval = setInterval(fetchChats, POLL_INTERVAL)
        notificationInterval = setInterval(fetchNotifications, POLL_INTERVAL)
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    // Clean up intervals and listener on component unmount
    return () => {
      clearInterval(chatInterval)
      clearInterval(notificationInterval)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [user])

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname, mapToggled])

  // useEffect(() => {
  //   const handleScroll = () => {
  //     const currentScrollY = window.scrollY

  //     // Always show header at the very top
  //     if (currentScrollY === 0) {
  //       if (topCollapsed) {
  //         setTopCollapsed(false)
  //       }
  //       setPrevScrollY(currentScrollY)
  //       return
  //     }

  //     // Skip if no significant scroll movement
  //     if (Math.abs(prevScrollY - currentScrollY) < 15) return

  //     const collapseThreshold = 50
  //     const bottomThreshold = document.documentElement.scrollHeight - window.innerHeight - 100
  //     const scrolledDown = currentScrollY > prevScrollY

  //     if (scrolledDown && currentScrollY > collapseThreshold && currentScrollY < bottomThreshold) {
  //       // Scrolling down past threshold - hide header
  //       if (!topCollapsed) {
  //         console.log('Scrolling down - hiding header')
  //         setTopCollapsed(true)
  //       }
  //     } else if (!scrolledDown && topCollapsed) {
  //       // Scrolling up - show header
  //       console.log('Scrolling up - showing header')
  //       setTopCollapsed(false)
  //     }

  //     setPrevScrollY(currentScrollY)
  //   }

  //   window.addEventListener('scroll', handleScroll, { passive: true })

  //   return () => {
  //     window.removeEventListener('scroll', handleScroll)
  //   }
  // }, [prevScrollY, topCollapsed])

  // Separate effect for iOS Safari viewport stabilization
  useEffect(() => {
    const handleViewportChange = () => {
      // Force a repaint on iOS to prevent navigation bar displacement
      if (isMobileBrowser() || Capacitor.isNativePlatform()) {
        const bottomNavs = document.querySelectorAll('.bottom-nav-ignore-safe')
        bottomNavs.forEach((nav) => {
          const element = nav as HTMLElement
          element.style.transform = 'translate3d(0,0,0)'
        })
      }
    }

    window.addEventListener('resize', handleViewportChange)
    window.addEventListener('orientationchange', handleViewportChange)

    return () => {
      window.removeEventListener('resize', handleViewportChange)
      window.removeEventListener('orientationchange', handleViewportChange)
    }
  }, []) // Empty dependency array since this only needs to run once

  const triggerHapticFeedback = async (style = ImpactStyle.Heavy) => {
    Haptics.impact({ style }).catch(() => {})
  }

  function isMobileBrowser() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }
  const { setUserLocation } = useContext(AuthContext)

  const handleLocationSearch = (location: { lat: number; lng: number }) => {
    setUserLocation(location) // Update user location
  } //just added

  const [statusBarHeight, setStatusBarHeight] = useState<number>(0)

  useEffect(() => {
    SafeArea.getStatusBarHeight().then(({ statusBarHeight }) => {
      setStatusBarHeight(statusBarHeight)
    })
  }, [])

  const [keyboardVisible, setKeyboardVisible] = useState(false)

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    const showPromise = Keyboard.addListener('keyboardWillShow', () => setKeyboardVisible(true))
    const hidePromise = Keyboard.addListener('keyboardWillHide', () => setKeyboardVisible(false))

    return () => {
      showPromise.then((h) => h.remove())
      hidePromise.then((h) => h.remove())
    }
  }, [])

  const FloatingPostButton = () => {
    const isMobileN = isMobile || isMobileBrowser() || Capacitor.isNativePlatform()
    return (
      <IconButton
        zIndex={1000}
        onClick={() => {
          triggerHapticFeedback(ImpactStyle.Medium)
          onImageSelectOpen()
        }}
        position="fixed"
        right={isMobileN ? '20px' : '40px'}
        bottom={isMobileN ? '100px' : '20px'}
        h={isMobileN ? '50px' : '80px'}
        w={isMobileN ? '50px' : '80px'}
        aria-label="post something"
        icon={
          <Icon viewBox="0 0 32 32" w={isMobileN ? '20px' : '32px'} h={isMobileN ? '20px' : '32px'}>
            <PlusSlim />
          </Icon>
        }
        variant="heavy"
      />
    )
  }

  if (isMobile || isMobileBrowser() || Capacitor.isNativePlatform())
    return (
      <Box userSelect="none">
        {user && (isCommunity || isOwnProfileGallery) && !keyboardVisible && <FloatingPostButton />}
        <ReportErrorModal
          isOpen={isReportErrorModalOpen}
          onClose={onReportErrorModalClose}
          onConfirm={(description: string) => {
            addReport.mutate({ description })
          }}
          isLoading={addReport.isLoading}
        />
        <Box
          style={{ position: 'sticky', top: '0' }}
          zIndex={1000}
          bg="white"
          userSelect="none"
        >
          <Spacer h={statusBarHeight + 'px'} userSelect="none" />
          <Box
            userSelect="none"
            w="100%"
            p={
              isMessages
                ? '0'
                : isProfile
                ? '0 20px 2px 20px'
                : isPlayExpand
                ? '60px 20px 0px 20px'
                : isPlay || isCommunity
                ? '50px 20px 0px 20px'
                : '50px 20px 20px 20px'
            }
            // m={isMessages ? '0' : '10px 0 0 0'}
            transition={transition}
          >
            {isMessages && <UserMessagesSearchHeader />}

            {isProfile && (
              <UserProfileHeader
                newNotifications={newNotification}
                newMessages={newMessage}
                user={user}
                isHost={isHost}
                setIsHost={setIsHost}
                onReportErrorModalOpen={onReportErrorModalOpen}
                logout={logout}
              />
            )}

            {displayDefaultHeader && <UserDefaultHeader newNotifications={newNotification} newMessages={newMessage} />}

            {isNotifications && <UserNotificationHeader />}

            {isSettings && <UserSettingsHeader />}

            {isBecomeHost && <UserTitleBackHeader title={location.pathname.includes('user/become-a-coach') ? 'Become a LVBL Coach' : 'Become a LVBL Host'} />}
            {isCreateEvent && <UserTitleBackHeader title="Create Event" />}
            {isEditEvent && <UserTitleBackHeader title="Edit Event" />}
            {isNewLocation && <UserTitleBackHeader title="Create new location" />}
            {isEditLocation && <UserTitleBackHeader title="Edit location" />}

            {isPlay && !isPlayExpand && (
              <>
                <Box w="100%" h={'12px'} transition={transition} />
                <PlaySearchFilter
                  collapsed={false}
                  hasMapToggle
                  onLocationSearch={handleLocationSearch} //just added
                />
              </>
            )}
            {isCommunity && user && shouldShowCommunityHeaderSearch && (
              <>
                <Box w="100%" h={'12px'} transition={transition} />
                <UserCommunitySearchHeader />
              </>
            )}
            {isEvents && (
              <>
                <Box w="100%" h={'12px'} transition={transition} />
                <Button
                  variant="heavy"
                  size="sm"
                  leftIcon={<Icon w="20px" h="20px" as={TbPlus} />}
                  onClick={() => {
                    navigate('/host/event/create')
                    triggerHapticFeedback(ImpactStyle.Medium)
                  }}
                >
                  Create Event
                </Button>
              </>
            )}
          </Box>
        </Box>

        <Box
          transition={transition}
          zIndex={1}
          minH={(isPlay && mapToggled) || isMessages ? undefined : '100vh'}
          overflowY="auto"
          overflowX="hidden"
          userSelect="none"
        >
          {!user && !authLoading && isProfile ? (
            <Center h="calc(100vh - 160px)">
              <Button
                variant="heavy"
                size="lg"
                onClick={() => navigate('/auth/login')}
              >
                Log in
              </Button>
            </Center>
          ) : (
            children
          )}
          <Spacer h="81px" />
        </Box>
        {(currentChat.length > 0 && isMessages && isMobileBrowser()) || keyboardVisible ? (
          <></>
        ) : (
          <Box
            className="bottom-nav-ignore-safe"
            style={{
              left: '0',
              right: '0',
              width: '100vw',
              zIndex: 1000,
              // Ensure consistent height
              minHeight: '80px',
            }}
          >
            <Divider />
            <Flex
              w="100%"
              h="80px"
              p="14px 28px 0px 28px"
              bg="white"
              zIndex="1"
              justifyContent="space-between"
              alignItems="center"
              pb="12px"
            >
              <MobileNavButton path="/user" icon={<Home />} filledIcon={<HomeFilled />} />
              {isHost && <MobileNavButton path="/host/events" icon={<Events />} filledIcon={<EventsFilled />} />}
              {!isHost && <MobileNavButton path="/user/play" icon={<Tennis />} filledIcon={<TennisFilled />} />}
              <MobileNavButton
                path="/user/community"
                icon={<Community />}
                filledIcon={<CommunityFilled />}
                disabled={false}
              />
              <MobileProfileButton
                path="/user/profile"
                avatar={user?.member_profile?.profile_image ?? ''}
                disabled={!user}
                tooltipOpen={mobileLoginTooltip}
                onTooltipToggle={() => setMobileLoginTooltip(!mobileLoginTooltip)}
              />
            </Flex>
          </Box>
        )}
      </Box>
    )

  return (
    <Flex h="100vh" w="100%" overflow="hidden">
      {user && (isCommunity || isOwnProfileGallery) && <FloatingPostButton />}
      <ReportErrorModal
        isOpen={isReportErrorModalOpen}
        onClose={onReportErrorModalClose}
        onConfirm={(description: string) => {
          addReport.mutate({ description })
        }}
        isLoading={addReport.isLoading}
      />
      <Box
        h="100%"
        w={isTablet ? '200px' : '235px'}
        bg="white"
        p="30px"
        userSelect="none" // Prevent selection of the logo
        zIndex={1000}
        pos="relative"
      >
        <Flex alignItems="center" gap="8px" mb="40px">
          <Box
            bgImage="/logo_black.svg"
            onClick={() => {
              navigate('/user')
            }}
            w="80px"
            h="33px"
            bgPos="center"
            bgSize="contain"
            bgRepeat="no-repeat"
          />
          <Box
            as="img"
            src="/beta.png"
            alt="Beta"
            w="56px"
            h="40px"
            objectFit="contain"
            flexShrink={0}
          />
        </Flex>
        <NavButton label="Home" path="/user" icon={<Home />} filledIcon={<HomeFilled />} />
        {isHost && <NavButton label="Events" path="/host/events" icon={<Events />} filledIcon={<EventsFilled />} />}
        {!isHost && <NavButton label="Play" path="/user/play" icon={<Tennis />} filledIcon={<TennisFilled />} />}
        <NavButton label="Community" path="/user/community" icon={<Community />} filledIcon={<CommunityFilled />} />
        <NavButton
          label="Messages"
          path="/user/messages"
          icon={
            newMessage ? <MessagesActive messagesCount={newMessage} color="#171C22" /> : <Messages color="#171C22" />
          }
          filledIcon={newMessage ? <MessagesActiveFilled messagesCount={newMessage} /> : <MessagesFilled />}
          disabled={!user}
        />
        <NavButton
          label="Inbox"
          path="/user/notifications"
          icon={newNotification ? <NotificationsActive notificationCount={newNotification} /> : <Notifications />}
          filledIcon={
            newNotification ? <NotificationsActiveFilled notificationCount={newNotification} /> : <NotificationFilled />
          }
          disabled={!user}
        />
        <NavButton label="ProShop" path="/user/shop" icon={<Shop />} filledIcon={<ShopFilled />} />
        <ProfileButton label="Profile" path="/user/profile" avatar={user?.member_profile?.profile_image ?? ''} disabled={!user} />

        <Box pos="absolute" bottom="30px" w="calc(100% - 60px)">
          {user ? (
            <Flex
              w="100%"
              justifyContent="left"
              alignItems="center"
              gap="10px"
              cursor="pointer"
              zIndex={9999}
              bgColor="white"
            >
              <Menu autoSelect={false}>
                <MenuButton as={Text} w="100%">
                  <Flex>
                    <Center>
                      <Icon w="24px" h="24px" viewBox="0 0 24 24" fill="none" color="#171C22">
                        <ListHamburger />
                      </Icon>
                    </Center>
                    <Center>
                      <Text ml="8px" variant="title" fontSize="md">
                        More
                      </Text>
                    </Center>
                  </Flex>
                </MenuButton>
                <MenuList borderRadius="10px" boxShadow="0px 12.914606094360352px 86.71235656738281px 0px #2B2C2D14">
                  <MenuItem
                    onClick={() => navigate('/user/settings/profile')}
                    fontSize="md"
                    fontWeight="500"
                    color="#171C22"
                  >
                    <Icon mr="8px" w="24px" h="24px" fill="none" viewBox="0 0 24 24">
                      <Settings />
                    </Icon>
                    <span>Settings</span>
                  </MenuItem>
                  <MenuItem fontSize="md" fontWeight="500" color="#171C22" onClick={onReportErrorModalOpen}>
                    <Icon mr="8px" w="24px" h="24px" fill="none" viewBox="0 0 24 24">
                      <ErrorPrompt />
                    </Icon>
                    <span>Report a problem</span>
                  </MenuItem>
                  <MenuItem
                    fontSize="md"
                    fontWeight="500"
                    color="#171C22"
                    onClick={() => navigate('/user/messages?to=f6f1a782-2afc-48ba-8683-3bab1d8cec07')}
                  >
                    <Icon mr="8px" w="24px" h="24px" fill="none" viewBox="0 0 16 16">
                      <GoQuestion />
                    </Icon>
                    <span>Contact LVBL</span>
                  </MenuItem>
                  <MenuItem
                    fontSize="md"
                    fontWeight="500"
                    color="#171C22"
                    onClick={() => navigate('/user/settings/wallet')}
                  >
                    <Icon mr="8px" w="24px" h="24px" fill="none" viewBox="0 0 15 15">
                      <HiOutlineCurrencyDollar />
                    </Icon>
                    <span>My Wallet</span>
                  </MenuItem>
                  <MenuItem
                    fontSize="md"
                    fontWeight="500"
                    color="#171C22"
                    onClick={() => window.open('https://open.spotify.com/playlist/72by2PSujjV5XExFDsX0uO', '_blank')}
                  >
                    <Icon mr="8px" w="24px" h="24px" fill="none" viewBox="0 0 16 16">
                      <PiRadio />
                    </Icon>
                    <span>LVBL Radio</span>
                  </MenuItem>
                  <MenuDivider />
                  {user?.member_profile?.is_host && (
                    <MenuItem fontSize="md" fontWeight="500" color="#171C22" onClick={() => setIsHost(!isHost)}>
                      <span>Switch to {isHost ? 'member' : 'host'} account</span>
                    </MenuItem>
                  )}
                  <MenuItem
                    onClick={() => {
                      logout()
                    }}
                    fontSize="md"
                    fontWeight="500"
                    color="#FF3B30"
                  >
                    <span>Log out</span>
                  </MenuItem>
                </MenuList>
              </Menu>
            </Flex>
          ) : (
            <Button
              variant="heavy"
              size="lg"
              w="100%"
              onClick={() => navigate('/auth/login')}
            >
              Log in
            </Button>
          )}
        </Box>
      </Box>
      <Divider orientation="vertical" zIndex={1000} userSelect={'none'} />
      <Box
        h="100%"
        w={isTablet ? 'calc(100% - 201px)' : 'calc(100% - 236px)'}
        zIndex={1}
        overflowY="auto"
        overflowX="hidden"
        sx={scrollbarStyle}
      >
        {children}
      </Box>
    </Flex>
  )
}

const UserWrapper = ({ children }: { children: ReactNode }) => {
  const { user } = useContext(AuthContext)
  const queryClient = useQueryClient()
  const {
    isOpen: isOnboardingOpen,
    onClose: onOnboardingClose,
    onOpen: onOnboardingOpen,
  } = useDisclosure()
  const {
    isOpen: isProfilePhotoPromptOpen,
    onClose: onProfilePhotoPromptClose,
    onOpen: onProfilePhotoPromptOpen,
  } = useDisclosure()
  const [hasDismissedProfilePhotoPrompt, setHasDismissedProfilePhotoPrompt] = useState(false)

  useHealthKitSync()

  const shouldPromptForProfilePhoto = Boolean(
    user &&
      !user.is_staff &&
      user.member_profile != null &&
      !user.member_profile.profile_image
  )

  useEffect(() => {
    if (user && !user.is_staff && user.member_profile == null) {
      onOnboardingOpen()
    }
  }, [user, onOnboardingOpen])

  useEffect(() => {
    setHasDismissedProfilePhotoPrompt(false)
  }, [user?.id])

  useEffect(() => {
    if (!shouldPromptForProfilePhoto) {
      onProfilePhotoPromptClose()
      return
    }

    if (!hasDismissedProfilePhotoPrompt) {
      onProfilePhotoPromptOpen()
    }
  }, [
    hasDismissedProfilePhotoPrompt,
    onProfilePhotoPromptClose,
    onProfilePhotoPromptOpen,
    shouldPromptForProfilePhoto,
  ])

  const handleProfilePhotoPromptClose = () => {
    setHasDismissedProfilePhotoPrompt(true)
    onProfilePhotoPromptClose()
  }

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) return

    const listener = App.addListener('appStateChange', (state) => {
      if (!state.isActive) return

      queryClient.invalidateQueries(['upcomingEvents'])
      queryClient.invalidateQueries(['pastEvents'])
      queryClient.invalidateQueries(['missingActivityEvents'])
      queryClient.invalidateQueries(['recentPastEvents'])
      queryClient.invalidateQueries(['getHealthStats'])
      queryClient.invalidateQueries(['getHealthEvents'])
    })

    return () => {
      listener.then((l) => l.remove())
    }
  }, [queryClient])

  // -------- GEOLOCATION PERMISSIONS --------

  const sendLocation = useMutation(['location'], putLocation)

  const requestLocation = async () => {
    try {
      const { location } = await Geolocation.checkPermissions()
      if (location === 'denied') return

      if (location !== 'granted' && Capacitor.isNativePlatform()) {
        const { location } = await Geolocation.requestPermissions()
        if (location === 'denied') return
      }

      // On web, getCurrentPosition() implicitly triggers the browser permission prompt
      const { coords } = await Geolocation.getCurrentPosition()

      sendLocation.mutate({
        lat: coords.latitude,
        lng: coords.longitude,
      })
    } catch {
      // Geolocation not available on this platform
    }
  }

  useEffect(() => {
    if (user?.member_profile != null && !user.is_staff) {
      requestLocation()
    }
  }, [user])

  // -------- PUSH NOTIFICATION PERMISSIONS --------

  const vapidKey = 'BJw_IkQbTJdxZBg-tfeHF_6broXdZMgQRmLfU8OmWnZRBt2oKQV5pcVMsJalvEdvkWEC82VDAbHbm0Q690PPD2w'

  const patchRegistrationID = useMutation(['registrationID'], patchRegistration)

  const getServiceWorkerRegistration = async () => {
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
          updateViaCache: 'none',
        })
        return registration
      } catch {
        return undefined
      }
    } else {
      return undefined
    }
  }

  const requestNotificationPermissions = async () => {
    const { receive } = await FirebaseMessaging.checkPermissions()
    if (receive == 'denied') return false
    if (receive == 'granted') return true

    const { receive: newReceive } = await FirebaseMessaging.requestPermissions()
    return newReceive == 'granted'
  }

  const setNotifications = async () => {
    const permission = await requestNotificationPermissions()
    const registration = await getServiceWorkerRegistration()
    if (permission) {
      FirebaseMessaging.getToken({
        vapidKey: vapidKey,
        serviceWorkerRegistration: registration,
      }).then((token) => {
        patchRegistrationID.mutate({
          registration_id: token.token,
        })
      })
    }
  }

  // -------- ATT PERMISSIONS --------

  const getATTStatus = async () => {
    const { status } = await AppTrackingTransparency.getStatus()
    return status
  }

  const requestPermission = async () => {
    await AppTrackingTransparency.requestPermission()
  }

  useEffect(() => {
    if (Capacitor.getPlatform() !== 'ios') return
    getATTStatus().then((status: string) => {
      if (status === 'notDetermined') {
        requestPermission()
      }
    })
  }, [])

  useEffect(() => {
    if (user?.member_profile != null) {
      setNotifications()
    }
  }, [user])

  return (
    <UserWrapperContextProvider>
      <HealthKitPromptModal />
      <ProfilePhotoPromptModal isOpen={isProfilePhotoPromptOpen} onClose={handleProfilePhotoPromptClose} />
      {user && !user.is_staff && user.member_profile == null && (
        <UserOnboardingModal
          isOpen={isOnboardingOpen}
          onClose={onOnboardingClose}
          onOpen={onOnboardingOpen}
        />
      )}
      <UserWrapperContent>{children}</UserWrapperContent>
    </UserWrapperContextProvider>
  )
}

export default UserWrapper
